import { useSearchParams } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";
import { ModuleSectorAnalysisReport } from "@app/pages/portfolioAnalysis/pdfSectorAnalysisReport/ModuleSectorAnalysisReport";

export const PdfAssetAllocationModuleSectorAnalysisReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id, sectorFocusId } =
    assetAllocationPages.getPdfModuleSectorAnalysisReportParams(searchParams);

  return (
    <ModuleSectorAnalysisReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      data1Id={data1Id}
      data2Id={data2Id}
      sectorFocusId={sectorFocusId}
      footer="Asset Allocation"
    />
  );
};
